<template>
    <div class="container-fluid">
          <div class="iframe-area">
            <iframe :src="downloadLink" width="0" height="0" id="download-iframe"></iframe>
          </div>
          <div class="row">
            <div class="col-md-4">
              <a class="win-download-link" :href="winDownload" download>
                {{ $t('downloads[0][0]') }}
              </a>
            </div>
            <div class="col-md-8">
              <a class="android-download-link" :href="androidDownload" target="_blank">{{ $t('downloads[0][2]') }}</a> 
              <i18n path="downloads[2][0]" tag="span">
                <template #googlePlay>
                  <a :href="googleAndroidDownload" target="_blank" rel="noopener">{{ $t('downloads[2][1]')}}</a>
                </template>
                <template #APK>
                  <a :href="androidAPK" target="_blank" rel="noopener">{{ $t('downloads[2][2]')}}</a>
                </template>
              </i18n> 
              <!--<i18n path="downloads[1][0]" tag="span">
                <template #setup>
                  <a :href="androidVideo" target="_blank" rel="noopener">{{ $t('downloads[1][1]')}}</a>
                </template>
              </i18n>-->
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <a class="mac-download-link" :href="macDownload" download>{{ $t('downloads[0][1]') }}</a>
            </div>
            <div class="col-md-8">
              <a :href="iosDownload" target="_blank" rel="noopener">{{ $t('downloads[0][3]') }}</a>
              <!--<i18n path="downloads[1][0]" tag="span">
                <template #setup>
                  <a :href="iosVideo" target="_blank" rel="noopener">{{ $t('downloads[1][1]')}}</a>
                </template>
              </i18n>-->
            </div>
          </div>
        </div>
</template>
<script>
import consts from '../assets/consts.js'

export default {
  name: 'DownloadLinks',
  data() {
    return {
      downloadLink: 'about:blank',
      winDownload: consts.winDownload,
      macDownload: consts.macDownload,
      androidDownload: consts.androidDownload,
      googleAndroidDownload: consts.androidDownload,
      iosDownload: consts.iosDownload,
      androidAPK: consts.androidAPK,
      androidVideo: consts.androidVideo,
      iosVideo: consts.iosVideo,
      winDownloadEU: consts.winDownloadEU,
      macDownloadEU: consts.macDownloadEU,
      winDownloadOC: consts.winDownloadOC,
      macDownloadOC: consts.macDownloadOC,
      macDownloadCN: consts.macDownloadCN,
      winDownloadCN: consts.winDownloadCN,
      androidDownloadCN: consts.androidDownloadCN,
      iosDownloadCN: consts.iosDownloadCN
    }
  },
  props: ['os'],
  created: function() {
    this.getDownloadLinks();
  },
  methods: {
    getDownloadLinks: function(){
      var params = this.$route.query;
      var domainEU = location.host.indexOf('.eu') > -1;
      var domainOC = location.host.indexOf('.nr') > -1;

      if (params !== '') {
        // EU params or domain
        if (('region' in params && params.region === 'eu') || domainEU) {
            this.winDownload = this.winDownloadEU
            this.macDownload = this.macDownloadEU
        }

        // OC params or domain
        if (('region' in params && params.region === 'oc') || domainOC) {
            this.winDownload = this.winDownloadOC
            this.macDownload = this.macDownloadOC
        }

        // CN language
        if (
          this.$route.params.lang === 'cn'
          && params.region !== 'eu'&& !domainEU
          && params.region !== 'oc' && !domainOC
        ) {
          this.winDownload = this.winDownloadCN
          this.macDownload = this.macDownloadCN
          this.androidDownload = this.androidDownloadCN
          this.iosDownload = this.iosDownloadCN
          this.androidAPK = this.androidDownloadCN
        }
      }
      if (this.os === "windows") {
        this.downloadLink = this.winDownload;
        return this.downloadLink;
      } else if (this.os === "mac") {
        this.downloadLink = this.macDownload;
        return this.downloadLink;
      } else {
        return this.downloadLink;
      }
    }
  }
}
</script>